import { Chip } from '@/shared/ui/chip'
import { Icon } from '@/shared/ui/icon'

// Метка «встречу видит клиент» в списке и на карточке: состояние должно
// читаться без открытия встречи — открытость наружу компании дороже, чем любой
// другой её атрибут.
export function CustomerVisibleBadge({ className }: { className?: string }) {
  return (
    <Chip tone="info" {...(className ? { className } : {})}>
      <Icon name="eye" size={12} />
      Видно заказчику
    </Chip>
  )
}
